.tag { display: inline-flex; flex: none; align-items: center; padding: 4px 8px; border: 1px solid var(--ink); font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; line-height: 1.2; color: var(--ink); white-space: nowrap; }
.tag[data-size='strip'] { padding: 6px 10px; font-size: 11px; }
.tag[data-type='rest'], .tag[data-missed='true'] { border-color: var(--line); color: var(--text-secondary); }
.tag[data-missed='true'] { text-decoration: line-through; }
